// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FilePayload__file-container-c60ad4 {
  display: flex;
  align-items: center;
}

.FilePayload__uploader-a396ff {
  color: var(--brand-primary-40);
}

.FilePayload__preview-content-eafc50 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-inline-start: var(--indent-8px);
  color: var(--chat-bubble-text-primary);
  overflow: hidden;
}

.FilePayload__header-bb2518 {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
}

.FilePayload__type-f17b78 {
  color: var(--chat-bubble-text-secondary);
  min-width: 100px;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/Payload/FilePayload/FilePayload.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,sCAAA;EACA,gBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;AACF;;AAEA;EACE,wCAAA;EACA,gBAAA;EACA,4BAAA;EACA,8CAAA;AACF","sourcesContent":[".file-container {\n  display: flex;\n  align-items: center;\n}\n\n.uploader {\n  color: var(--brand-primary-40);\n}\n\n.preview-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-inline-start: var(--indent-8px);\n  color: var(--chat-bubble-text-primary);\n  overflow: hidden;\n}\n\n.header {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n}\n\n.type {\n  color: var(--chat-bubble-text-secondary);\n  min-width: 100px;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"file-container": `FilePayload__file-container-c60ad4`,
	"fileContainer": `FilePayload__file-container-c60ad4`,
	"uploader": `FilePayload__uploader-a396ff`,
	"preview-content": `FilePayload__preview-content-eafc50`,
	"previewContent": `FilePayload__preview-content-eafc50`,
	"header": `FilePayload__header-bb2518`,
	"type": `FilePayload__type-f17b78`
};
module.exports = ___CSS_LOADER_EXPORT___;
